export default __webpack_public_path__ + "static/media/profile1.49468751.jpg";